import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme, Typography } from '@material-ui/core';

import { Page } from '../../components/Page';
import { PageBody } from '../../components/PageBody';
import { BackAppBar } from '../../components/BackAppBar';

type TermsPageProps = {};

TermsPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        '& .MuiTypography-h4': {
            margin: theme.spacing(2, 0),
        },
        '& .MuiTypography-h6': {
            marginTop: theme.spacing(2),
        },
        '& .MuiTypography-body1': {
            margin: theme.spacing(1, 0),
        },
    },
}));

function TermsPage(props: TermsPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Page>
            <BackAppBar title="使用條款" />
            <PageBody className={classes.root} maxWidth="lg">
                <Typography variant="h4" style={{ textAlign: 'center' }}>使用條款</Typography>
                <Typography variant="body1">本超淨精密科技股份有限公司（ 以下簡稱本網站 ）的所有使用者適用，本網站由超淨精密科技股份有限公司（ 以下稱本公司 ）營運。您對本網站的使用受以下使用條款規範。您使用本網站前，請仔細詳閱以下條款。您使用本網站或本網站的任何部分，即代表您已閱讀本使用條款並同意接受其約束。</Typography>

                <Typography variant="h6">一、本網站的目的和內容</Typography>
                <Typography variant="body1">1.1 本網站中的全部資訊和資料僅為 超淨精密科技股份有限公司 提供一般資訊和推廣產品和服務之用。此類資訊和資料並不代表超淨精密科技股份有限公司、官方零售商或其他第三方提供產品和 / 或服務之要約，亦不構成對超淨精密科技股份有限公司產品和 / 或服務之使用建議或其他說明。</Typography>
                <Typography variant="body1">1.2 本網站可能含有超淨精密科技股份有限公司 全球產品和服務之資訊，這些產品或服務並非在所有地點皆有供應。提及我們的產品或服務並非暗示該產品或服務現在或將來會在您的所在地供應。</Typography>

                <Typography variant="h6">二.用戶內容</Typography>
                <Typography variant="body1">2.1 請注意，您在本網站發布資訊時(例如論壇或留言)，其他用戶可能會接觸到該資訊。因此，您應謹慎選擇發布之資訊及向其他用戶提供該等資訊。</Typography>
                <Typography variant="body1">2.2 超淨精密科技股份有限公司 對您在本網站可能發布的文字、檔案、圖片、照片、錄影、聲音、原創作品或任何其他資訊（ 用戶內容 ）不主張任何所有權。用戶內容發布後，您繼續對其保有完整所有權，並繼續有權以任何方式使用這些內容。在本網站或透過本網站發布您的用戶內容，即表示您允許我們在本網站及透過本網站或第三方平台（LINE、Facebook、Twitter 等）含 超淨精密科技 之部分，非專屬的、可再授權的、可移轉的、無償的在全球範圍使用、修改、公開表演、公開展示、複製和分發用戶內容，直至您從本網站刪除您的用戶內容。</Typography>
                <Typography variant="body1">2.3 您聲明並保證︰(i) 您擁有在本網站發布用戶內容之所有權，或得授權上述內容。同時，(ii) 在本網站發布您的「用戶內容」不違反任何個人或公司的隱私權、公開權、著作權、商標權、合約權利或任何其他權利。</Typography>
                <Typography variant="body1">2.4 您對在本網站發布的用戶內容承擔完全責任。您不得在本網站發布、傳送或分享非由您創作或您未有發布權限的用戶內容。用戶內容在發布前不一定經 超淨精密科技 審查，也不一定反映 超淨精密科技的觀點或政策。超淨精密科技 對「用戶內容」，或您向其他用戶傳送的任何資料或資訊或其準確性和可靠性不作任何明示或暗示的保證。您不得發布或傳送任何非法、威脅、中傷、誹謗、猥褻、造謠、煽動、色情或褻瀆性的材料，或其他可構成或鼓勵犯罪之行為、導致民事責任或其他違反法律的任何資訊</Typography>
                <Typography variant="body1">2.5 本網站提供用戶於提供特定資料後開設個人帳號之機會。特別是，您將被要求選擇一組電子郵件帳號及密碼。您對密碼之保密全權負責。您同意無論何時皆不會使用他用戶之帳號、電子郵件帳號或密碼，亦不會向第三人透露您的密碼。如果您懷疑任何未經授權之帳號或密碼之使用，您同意將立即通知我們。您對於您的帳號之使用全權負責。</Typography>
                <Typography variant="body1">2.6 超淨精密科技股份有限公司 明確保留其刪除任何人發布或傳送違反以上規定之資訊或資料之權利。超淨精密科技 將全力配合任何執法機關或法院之要求或指示，該要求或指示為超淨精密科技需揭露此類資訊或資訊發布人之身分。</Typography>

                <Typography variant="h6">三.智慧財產權</Typography>
                <Typography variant="body1">3.1 本網站，連同本網站內包含的任何資訊、文字、圖片、照片、聲音和影像、設計、圖像、標誌、符號、名稱、產品、企業名稱及全部軟體和所有其他檔案及其選輯與安排（「本網站內容」），均受法律保護，特別是 超淨精密科技、其關係企業、其用戶或其授權人擁有的著作權、商標和設計權。未經我們事前書面許可，您不得以任何形式或方式更改、複製、散布、透過框架顯示、翻印、再版、下載、顯示、發布、傳送或銷售全部或部分本網站內容，惟您在本網站合法發布的個人用戶內容不受前述限制。此外，未經 超淨精密科技 事前書面核准，不得將任何數碼內容複製到其他程式內。</Typography>
                <Typography variant="body1">3.2 在您有權使用本網站的前提下，我們允許您於權限內造訪和使用本網站和本網站內容，及僅為個人和非商業目的下載或列印一份您透過適當方式造訪本網站內容的任意部分，條件是您必須保留未經更動的全部著作權或其他專屬權聲明。此許可受使用條款約束，不包括使用資料探勘、機器人或類似的資料收集或提取方法。除您個人的用戶內容外，您不得在任何網際網路、內聯網或外聯網站中上傳或轉發本網站內容，或將其併入其他資料庫或彙編檔案，並嚴禁以任何其他模式使用本網站內容。除在此明確授權的使用外，未經超淨精密科技股份有限公司事前書面許可，嚴禁以任何模式使用本網站或本網站內容，該行為將同時終止在此授予的許可。任何未經授權的使用亦可能違反適用法律，包括但不限於著作權和商標法及適用的通訊規範和法規。除非在此有明確聲明，使用條款中的任何內容均不得被理解為授予任何智慧財產權許可。</Typography>
                <Typography variant="body1">3.3 本網站顯示的「超淨精密」及其他商標、標誌、字符、頁面標題、按鈕圖示、程式碼、服務名稱和其他標誌（統稱為「商標」）受超淨精密科技股份有限公司或其關係企業的商標及其他權利的約束。未經我們事前書面許可，不得以任何可能造成混淆的模式將超淨精密科技股份有限公司商標（包括作為商標和/ 或網域名的一部分）與其他產品或服務連同使用，且不得對其進行完全或部分複製、模仿或使用。除使用條款中允許的使用外，嚴禁使用 / 濫用本網站上或其他本網站內容中顯示的商標</Typography>

                <Typography variant="h6">四.免責聲明</Typography>
                <Typography variant="body1">4.1 儘管超淨精密科技股份有限公司投入合理努力，在本網站上收錄及時準確的資訊，超淨精密科技股份有限公司對「本網站內容」不作任何保證或聲明，該內容以「原樣」形式提供。超淨精密科技 亦不會保證或聲明您在使用「本網站內容」時不會侵犯到非 超淨精密科技擁有或關聯第三方的權利。</Typography>
                <Typography variant="body1">4.2 超淨精密科技股份有限公司對由於您造訪、使用或瀏覽本網站或從本網站下載任何材料、數據、文字、圖片、影像或聲音而造成的、對您電腦設備或其他財產的損失或可能遭受的病毒感染不承擔任何責任或法律責任。</Typography>
                <Typography variant="body1">4.3 超淨精密科技股份有限公司有權中斷或中止本網站的任何或全部功能。超淨精密科技 對中斷或中止本網站全部或部分功能不承擔任何責任或法律責任，無論其是否由於 超淨精密科技 或其關係企業或任何第三方的行為或不作為而造成的。</Typography>
                <Typography variant="body1">4.4 本網站內容可能含有不準確的技術資訊或排版錯誤。超淨精密科技 保留其在不作通知的前提下，隨時對本網站內容進行更改、更正和/或改善的權利。</Typography>

                <Typography variant="h6">五.與其他網站之間的連結</Typography>
                <Typography variant="body1">5.1 超淨精密科技股份有限公司對本網站連結的網站既無控制權也未予認可，超淨精密科技 對本網站連結的任何或全部網站均未進行審核，因此您承認超淨精密科技股份有限公司對任何本網站以外的頁面或連結到「本網站」的任何其他網站內容不承擔責任。由您承擔造訪本網站以外頁面及連結到第三方網站的全部責任。</Typography>
                <Typography variant="body1">5.2 您對本網站、本網站以外頁面或其他網站的連結自承風險。使用此類連結時，您須了解連結到的網站適用其自身的法律聲明和隱私權政策，並可能與超淨精密科技股份有限公司的此類政策不同。如果您想連結到本網站，則只能進行連結，而不得複製首頁，同時須受以下條件約束。</Typography>
                <Typography variant="body1">5.3 禁止超淨精密科技股份有限公司以外的成員通過網站或網站元素以框架模式顯示本網站。同樣禁止在超淨精密科技股份有限公司以外的成員以內部連結或任何其他形式嵌入本網站中的內容。</Typography>

                <Typography variant="h6">六.造訪服務</Typography>
                <Typography variant="body1">6.1 雖然超淨精密科技股份有限公司努力確保本網站每天 24 小時正常服務，但對由於任何原因，在任意時間或期間未能提供服務不承擔責任。</Typography>
                <Typography variant="body1">6.2 發生系統故障、進行維護或維修時，或發生超出我們得控制的原因時，可能會造成本網站暫時無法造訪且不另作通知。</Typography>

                <Typography variant="h6">七.責任限制</Typography>
                <Typography variant="body1">7.1 在法律許可的最大範圍內，除由故意或重大過失造成的損失外，超淨精密科技股份有限公司及任何其他公司，包括其主管、經理、員工、股東或其代理人，對與本網站有任何形式的關聯或與使用、無法使用或由於使用本網站、連結到本網站的任何網站或這些網站上的資料而給您或第三方造成的任何程度或形式的損失或損害（包括但不限於任何直接、間接由此產生的損失或　損害，或收入、收益、聲譽或資料的損失）拒絕承擔任何責任和法律責任，包括但不限於由於您造訪、使用或瀏覽本網站或從本網站或連結到本網站的其他網站下載資料而可能對您的電腦設備、軟體、資料或其他財產因病毒感染而導致的損失或損害。</Typography>

                <Typography variant="h6">八.隱私權</Typography>
                <Typography variant="body1">8.1 我們關注您的隱私權及對您個人資料的保護。 請參閱我們的隱私權政策。</Typography>
            </PageBody>
        </Page>
    );
}

export { TermsPage };
